import * as UM from 'app/um/models/essette-api';
import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { apiCall } from 'app/shared/lib/api/api';
import { AuthService } from 'app/um/services/auth-service';
import { openProviderLocationSummary } from 'app/cd/components/summary/provider/provider-summary';
import { AuthContext } from 'app/um/lib/auth-context';

@autoinject()
export class ProviderInformation extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected authId: string | null = null;

    protected auth: UM.Auth | null = null;

    protected showProviderSummaryLink: boolean = false;
    protected openProviderLocationSummary = openProviderLocationSummary;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly authService: AuthService,
        private readonly context: AuthContext,
        ...rest: any[]) {

        super(...rest);
        this.checkPermissions();
    }

    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        // attempt to get info off the context first; otherwise query the API
        if(this.context.auth?.id && this.context.auth.id === this.authId) {
            this.auth = this.context.auth;
        } else {
            await this.loadAuth();
        }
    }

    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        this.showProviderSummaryLink = this.accountContext.hasRouteAccess('cd.provider.summary');
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuth(): Promise<void> {
        if(!this.authId) return;

        const includes: string[] = [
            'provider.requested',
            'provider.requesting',
            'provider.servicing',
            'provider.attending',
            'provider.requested.location',
            'provider.requesting.location',
            'provider.servicing.location',
            'provider.attending.location',
            'provider.requested.location.provider',
            'provider.requesting.location.provider',
            'provider.servicing.location.provider',
            'provider.attending.location.provider',
        ];

        const fields: string[] = [
            'provider.attending.location.description',
            'provider.attending.location.provider.description',
            'provider.requested.location.description',
            'provider.requested.location.provider.description',
            'provider.requesting.location.description',
            'provider.requesting.location.provider.description',
            'provider.servicing.location.description',
            'provider.servicing.location.provider.description',
        ];

        try {
            this.state.beginLoad();

            const response = await this.authService.loadAuth(this.authId, includes, undefined, fields);
            this.auth = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
